import { SetStateAction } from "react";
import { TFunction } from "i18next";
import { RemoteCompany } from "../../../hooks/Remote/Companies/useRemoteFetchCompanies";
import { CompanyUnits } from "../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";
import { Colleague } from "../../../features/Connections/types/Colleague.type";
import { ItemPermEntityOptions } from "./List-Permission-Select.component";

export function initialItemPerm({
  props,
  actions
}: {
  props: {
    permRow: {
      affectedCompanies: string[];
      affectedDepartments: string[];
      affectedUsers: string[];
    };
    remoteCompanies: RemoteCompany[];
    remoteDepartments: CompanyUnits[];
    remoteAllUsers: Colleague[];
  };
  actions: {
    setSelectedCompanies: (value: SetStateAction<ItemPermEntityOptions[]>) => void;
    setSelectedDepartments: (value: SetStateAction<ItemPermEntityOptions[]>) => void;
    setSelectedUsers: (value: SetStateAction<ItemPermEntityOptions[]>) => void;
    t: TFunction;
  };
}) {
  const { permRow, remoteCompanies, remoteDepartments, remoteAllUsers } = props;
  const { setSelectedCompanies, setSelectedDepartments, setSelectedUsers, t } = actions;

  // companies
  selectAffectedCompanies(permRow, remoteCompanies, setSelectedCompanies, t);

  // departments
  selectAffectedDepartments(permRow, remoteDepartments, setSelectedDepartments, t);

  // users
  selectAffectedUsers(permRow, remoteAllUsers, setSelectedUsers);
}

const selectAffectedCompanies = (
  permRow: { affectedCompanies: string[] },
  remoteCompanies: RemoteCompany[],
  setSelectedCompanies: (value: SetStateAction<ItemPermEntityOptions[]>) => void,
  t: TFunction
) => {
  const arrAffectedCompanies = permRow.affectedCompanies;

  if (!arrAffectedCompanies) return;

  const filtered: ItemPermEntityOptions[] = remoteCompanies
    .filter(company => arrAffectedCompanies.includes(company.id.toString()))
    .map(comp => ({ id: comp.id.toString(), name: comp.name ?? `${t("Company")} ${comp.id}` }));

  if (!filtered.length) return;

  setSelectedCompanies(filtered);
};

const selectAffectedDepartments = (
  permRow: { affectedDepartments: string[] },
  remoteDepartments: CompanyUnits[],
  setSelectedDepartments: (value: SetStateAction<ItemPermEntityOptions[]>) => void,
  t: TFunction
) => {
  const arrAffectedDepartments = permRow.affectedDepartments;

  if (!arrAffectedDepartments) return;

  const filtered: ItemPermEntityOptions[] = remoteDepartments
    .filter(department => arrAffectedDepartments.includes(department.id))
    .map(depart => ({
      id: depart.id.toString(),
      name: depart.name ?? `${t("Department")} ${depart.id}`
    }));

  if (!filtered.length) return;

  setSelectedDepartments(filtered);
};

const selectAffectedUsers = (
  permRow: { affectedUsers: string[] },
  remoteAllUsers: Colleague[],
  setSelectedUsers: (value: SetStateAction<ItemPermEntityOptions[]>) => void
) => {
  const arrAffectedUsers = permRow.affectedUsers;

  if (!arrAffectedUsers) return;

  const filtered: ItemPermEntityOptions[] = remoteAllUsers
    .filter(user => arrAffectedUsers.includes(user.userId))
    .map(user => ({ id: user.userId, name: `${user.firstName} ${user.surname}` }));

  if (!filtered.length) return;

  setSelectedUsers(filtered);
};
